import React, { forwardRef, useState } from "react"
import PropTypes from "prop-types"
import css from "./InputField.scss"

const InputField = forwardRef((props, inputRef) => {
    const {
        name,
        label,
        type,
        onChange,
        onBlur,
        placeholder,
        disabled,
        alertMessage,
        alertType,
        maxLength,
        value, // Please send the updated state value to be reflected
        onFocus,
        countDown,
        focused,
        borderType,
        onKeyUp,
        required = false,
    } = props

    const alertTextClasses = {
        success: "successColor",
        caution: "cautionColor",
        error: "errorColor",
    }
    const borderClasses = {
        primary: "borderBottomPrimary",
        tertiary: "borderBottomTertiary",
    }
    const borderClassName = css[borderClasses[borderType]]
    const alertTextClassName = css[alertTextClasses[alertType]]
    const [textLength, setTextLength] = useState(value?.length || 0)
    const onValueChange = (event) => {
        if (event.target.value?.length <= maxLength) {
            setTextLength(event.target.value.length)
        }

        if (onChange && typeof onChange === "function") {
            onChange(event.target.value)
        }
    }

    const onClickOutside = () => {
        if (onBlur && typeof onBlur === "function") {
            onBlur()
        }
    }

    const onInputFocus = () => {
        if (onFocus && typeof onFocus === "function") {
            onFocus()
        }
    }

    return (
        <div className={`flex flexColumn ${css.inputParent}`}>
            <div className={`l5Regular textSecondary  ${borderClassName} ${focused ? css.focused : ""}  `}>
                {label && (
                    <label htmlFor={name} className={`${css.inputLabel} bodyRegular`}>
                        {label}
                    </label>
                )}
                <div className="flex justifyBetween">
                    <input
                        id={name}
                        placeholder={placeholder}
                        type={type}
                        className={`${css.inputBox}`}
                        name={name}
                        ref={inputRef}
                        disabled={disabled}
                        onChange={onValueChange}
                        onBlur={onClickOutside}
                        value={value}
                        maxLength={maxLength}
                        onFocus={onInputFocus}
                        onKeyUp={onKeyUp}
                        aria-required={required}
                        aria-invalid={!!alertMessage}
                        aria-describedby={alertMessage && name && `${name}-error`}
                    />
                    {countDown && (
                        <div className={` textTertiary  smallSemiBold ${css.countDown}`}>{countDown}</div>
                    )}
                </div>
            </div>

            <div
                className={`flex marginTop-4 ${alertMessage ? "justifyBetween" : "justifyEnd"} ${
                    css.alertContainer
                }`}
            >
                {alertMessage ? (
                    <span
                        aria-live="polite"
                        id={`${name ? `${name}-error` : ""}`}
                        className={`smallRegular ${alertTextClassName}`}
                    >
                        {alertMessage}
                    </span>
                ) : null}
                {maxLength ? (
                    <span className={`smallRegular ${css.lengthText}`}>{`${textLength} / ${maxLength}`}</span>
                ) : null}
            </div>
        </div>
    )
})

InputField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    alertMessage: PropTypes.string,
    alertType: PropTypes.string,
    maxLength: PropTypes.number,
    inputRef: PropTypes.ref,
    value: PropTypes.string || PropTypes.number,
    onFocus: PropTypes.func,
    countDown: PropTypes.string,
    focused: PropTypes.bool,
    borderType: PropTypes.string,
    required: PropTypes.bool,
}

export default InputField
